<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="screeload disable-click" id="showLoading" *ngIf="!disableLoader">
    <mat-spinner diameter="50" class="m-auto"></mat-spinner>
</div>
<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>